module.exports = __webpack_public_path__ + "media/images/partnerhub_insights-54d7afd97d4326610a5771dae2edf8bc.svg";